export default "__VITE_ASSET__f19cb455__"